var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0498 13.6026C18.2032 14.4306 17.0498 14.9 15.8421 14.9C14.6344 14.9 13.481 14.4306 12.6344 13.6026C11.7886 12.7755 11.318 11.6589 11.318 10.5C11.318 9.34106 11.7886 8.2245 12.6344 7.39736C13.481 6.56939 14.6344 6.1 15.8421 6.1C17.0498 6.1 18.2032 6.56939 19.0498 7.39736C19.8956 8.2245 20.3662 9.34106 20.3662 10.5C20.3662 11.6589 19.8956 12.7755 19.0498 13.6026ZM7.1 25.7238C7.1 22.1219 10.0905 19.1625 13.8341 19.1625H17.8501C21.5937 19.1625 24.5842 22.1219 24.5842 25.7238C24.5842 25.798 24.5156 25.9 24.3792 25.9H7.30496C7.16863 25.9 7.1 25.798 7.1 25.7238Z",
    stroke: "#757575",
    strokeWidth: 2.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileInactive);
export default __webpack_public_path__ + "static/media/profile-inactive.22d87891f245bdddae7a0b48f15fd2f3.svg";
export { ForwardRef as ReactComponent };